import React, { useRef } from 'react'
import { useMagnetic } from '../../hooks/useMagnetic'

/**
 * Button wrapper with magnetic pointer-pull effect.
 * @param {number} strength - magnetic strength multiplier (default 0.28)
 */
export function MagneticButton({ children, strength = 0.28, className = '', ...rest }) {
    const ref = useRef(null)
    useMagnetic(ref, strength)

    return (
        <button ref={ref} data-magnetic className={className} {...rest}>
            {children}
        </button>
    )
}
